import { render, staticRenderFns } from "./ListItemPage.vue?vue&type=template&id=3c09b3d2"
import script from "./ListItemPage.vue?vue&type=script&lang=js"
export * from "./ListItemPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports